import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconSetup from './sidebar-icon-setup.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconSetup {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconSetup';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconSetupIcon = svgIconWrapper(SvgComponent);
